/**
 * @generated SignedSource<<330353dc92b85c467568b8a8d300dd04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ArtistProfileQuery$variables = {
  slug: string;
};
export type ArtistProfileQuery$data = {
  readonly artistBySlug: {
    readonly displayName: string;
    readonly spotifyApiId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ArtistInfo_artist" | "ReleasesGrid_artist">;
  } | null;
};
export type ArtistProfileQuery = {
  response: ArtistProfileQuery$data;
  variables: ArtistProfileQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spotifyApiId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releaseType",
  "storageKey": null
},
v10 = [
  (v7/*: any*/),
  (v5/*: any*/),
  (v8/*: any*/),
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastActiveAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "isVisible",
    "value": true
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releaseDate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "ArtistNode",
  "kind": "LinkedField",
  "name": "artist",
  "plural": false,
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserNode",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v5/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "ActorInterface",
      "abstractKey": "__isActorInterface"
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "soundLink",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tracksCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ArtistProfileQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ArtistNode",
        "kind": "LinkedField",
        "name": "artistBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ArtistInfo_artist"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReleasesGrid_artist"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArtistProfileQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ArtistNode",
        "kind": "LinkedField",
        "name": "artistBySlug",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNode",
            "kind": "LinkedField",
            "name": "spotifyProfile",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "about",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "FeaturedDealNodeConnection",
            "kind": "LinkedField",
            "name": "featuredDeals",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FeaturedDealNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FeaturedDealNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalAmountRaising",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReleaseNodeConnection",
                            "kind": "LinkedField",
                            "name": "releases",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ReleaseNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReleaseNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v10/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UnreleasedReleaseNodeConnection",
                            "kind": "LinkedField",
                            "name": "unreleasedReleases",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UnreleasedReleaseNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UnreleasedReleaseNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v10/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "OfferFeaturedDealInterface",
                        "abstractKey": "__isOfferFeaturedDealInterface"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProfileNodeConnection",
            "kind": "LinkedField",
            "name": "profiles",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "platform",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "location",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GenreNode",
            "kind": "LinkedField",
            "name": "genre",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "genre",
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnershipStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ArtistSeekingServiceNodeConnection",
            "kind": "LinkedField",
            "name": "seekingServices",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ArtistSeekingServiceNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ArtistSeekingServiceNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "service",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "isAccepted",
                "value": true
              }
            ],
            "concreteType": "OfferNodeConnection",
            "kind": "LinkedField",
            "name": "offers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OfferNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OfferNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PartnerNode",
                        "kind": "LinkedField",
                        "name": "partner",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*: any*/),
                              (v12/*: any*/),
                              (v2/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserNode",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "actor",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v7/*: any*/),
                                      (v5/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProfileNode",
                                            "kind": "LinkedField",
                                            "name": "spotifyProfile",
                                            "plural": false,
                                            "selections": [
                                              (v7/*: any*/),
                                              (v5/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "ArtistNode",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CompanyNode",
                                    "kind": "LinkedField",
                                    "name": "company",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v2/*: any*/),
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "PartnerNode",
                                "abstractKey": null
                              }
                            ],
                            "type": "ActorInterface",
                            "abstractKey": "__isActorInterface"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "offers(isAccepted:true)"
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "ReleaseNodeConnection",
            "kind": "LinkedField",
            "name": "releases",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReleaseNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReleaseNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "upc",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          (v7/*: any*/),
                          (v16/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v17/*: any*/)
                        ],
                        "type": "ReleaseInterface",
                        "abstractKey": "__isReleaseInterface"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "releases(isVisible:true)"
          },
          {
            "alias": null,
            "args": (v13/*: any*/),
            "concreteType": "UnreleasedReleaseNodeConnection",
            "kind": "LinkedField",
            "name": "unreleasedReleases",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnreleasedReleaseNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnreleasedReleaseNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updatedAt",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          (v7/*: any*/),
                          (v16/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v17/*: any*/),
                          (v14/*: any*/)
                        ],
                        "type": "ReleaseInterface",
                        "abstractKey": "__isReleaseInterface"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "unreleasedReleases(isVisible:true)"
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6b5ee0c847c97a140b06cda762df5f76",
    "id": null,
    "metadata": {},
    "name": "ArtistProfileQuery",
    "operationKind": "query",
    "text": "query ArtistProfileQuery(\n  $slug: String!\n) {\n  artistBySlug(slug: $slug) {\n    displayName\n    spotifyApiId\n    ...ArtistInfo_artist\n    ...ReleasesGrid_artist\n    id\n  }\n}\n\nfragment ArtistAttributes_artist on ArtistNode {\n  user {\n    lastActiveAt\n    id\n  }\n  location\n  genre {\n    genre\n    id\n  }\n  partnershipStatus\n  seekingServices {\n    edges {\n      node {\n        service\n        id\n      }\n    }\n  }\n}\n\nfragment ArtistInfo_artist on ArtistNode {\n  displayName\n  imageUrl\n  spotifyApiId\n  spotifyProfile {\n    imageUrl\n    id\n  }\n  about\n  featuredDeals {\n    edges {\n      __typename\n    }\n  }\n  profiles {\n    edges {\n      node {\n        ...SocialLinks_profiles\n        id\n      }\n    }\n  }\n  ...ArtistAttributes_artist\n  ...FeaturedDeals_artist\n}\n\nfragment AvatarIcon_actor on ActorInterface {\n  __isActorInterface: __typename\n  user {\n    lastActiveAt\n    ...useUserThumbnailUrl_user\n    id\n  }\n}\n\nfragment AvatarName_actor on ActorInterface {\n  __isActorInterface: __typename\n  __typename\n  slug\n  displayName\n  ...AvatarIcon_actor\n  ... on PartnerNode {\n    company {\n      slug\n      displayName\n      id\n    }\n  }\n}\n\nfragment DealListItem_featureddeal on FeaturedDealNode {\n  id\n  totalAmountRaising\n  ...ReleaseIconsNames_query\n}\n\nfragment FeaturedDeals_artist on ArtistNode {\n  featuredDeals {\n    edges {\n      node {\n        id\n        ...DealListItem_featureddeal\n      }\n    }\n  }\n}\n\nfragment ReleaseCard_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  __typename\n  id\n  artist {\n    ...useMessage_actor\n    id\n  }\n  ...ReleaseInfoCardView_release\n}\n\nfragment ReleaseIconsNames_query on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  ...ReleaseIconsNames_releaseImages\n  ...useFeaturedDealTitle\n}\n\nfragment ReleaseIconsNames_releaseImages on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  releases {\n    edges {\n      node {\n        thumbnailUrl\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        thumbnailUrl\n        id\n      }\n    }\n  }\n}\n\nfragment ReleaseInfoCardView_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  thumbnailUrl\n  soundLink\n  name\n  ...useReleaseMetadata_release\n}\n\nfragment ReleasesGrid_artist on ArtistNode {\n  offers(isAccepted: true) {\n    edges {\n      node {\n        __typename\n        id\n      }\n    }\n  }\n  releases(isVisible: true) {\n    edges {\n      node {\n        __typename\n        id\n        upc\n        releaseDate\n        ...ReleaseCard_release\n      }\n    }\n  }\n  unreleasedReleases(isVisible: true) {\n    edges {\n      node {\n        __typename\n        id\n        updatedAt\n        ...ReleaseCard_release\n      }\n    }\n  }\n  ...TeamCard_artist\n}\n\nfragment SocialLinks_profiles on ProfileNode {\n  id\n  url\n  platform\n}\n\nfragment TeamCard_artist on ArtistNode {\n  offers(isAccepted: true) {\n    edges {\n      node {\n        partner {\n          id\n          ...AvatarName_actor\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useArtistThumbnailUrl_artist on ArtistNode {\n  thumbnailUrl\n  spotifyProfile {\n    thumbnailUrl\n    id\n  }\n}\n\nfragment useFeaturedDealTitle on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  releases {\n    edges {\n      node {\n        name\n        releaseType\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        name\n        releaseType\n        id\n      }\n    }\n  }\n}\n\nfragment useMessage_actor on ActorInterface {\n  __isActorInterface: __typename\n  user {\n    ...useMessage_user\n    id\n  }\n}\n\nfragment useMessage_user on UserNode {\n  id\n}\n\nfragment useReleaseMetadata_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  releaseType\n  tracksCount\n  releaseDate\n}\n\nfragment useUserThumbnailUrl_user on UserNode {\n  actor {\n    __typename\n    thumbnailUrl\n    ...useArtistThumbnailUrl_artist\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1dd90fc1884cbbb732bc61db57241cd2";

export default node;
